module.exports = __webpack_public_path__ + "static/img/reference pics_Sixth Naphtha2.eaba31d1.jpg";